export default __webpack_public_path__ + "static/media/movie-details-page-dark.6ff09bd4.png";